import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPreApprovalLoanDetails } from "../pre-approval-loan-wrapper/actions";
import PreApprovalReadDetails from "./component";

const mapStateToProps = ({
    preApprovalLoan: {
        maxPermissibleRepaymentPerWeek,
        financeData,
        inHouseFinanceEligibilityFinance,
        maxLoanAmount,
        financeQuotes,
        bestInterestRate,
        comparisonRate,
        absolutePermissibleLoanAmount
    }
}) => ({
    financeData,
    maxLoanAmount,
    financeQuotes,
    inHouseFinanceEligibilityFinance,
    bestInterestRate,
    comparisonRate,
    maxPermissibleRepaymentPerWeek,
    absolutePermissibleLoanAmount
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPreApprovalLoanDetailsConnect: getPreApprovalLoanDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PreApprovalReadDetails);
